"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postNotification = postNotification;
exports.removeNotification = removeNotification;

var _ActionTypes = _interopRequireDefault(require("./ActionTypes"));

function postNotification(notification) {
  return {
    type: _ActionTypes.default.ADD_NOTIFICATION,
    payload: notification
  };
}

function removeNotification(id) {
  return {
    type: _ActionTypes.default.REMOVE_NOTIFICATION,
    payload: {
      id: id
    }
  };
}